import type React from 'react';
import { Skeleton } from '@heroui/react';
import { OverviewCard } from './OverviewCard';

type OverviewCardSkeletonProps = {
    /** Literal testid prefix, e.g. `cash-runway`. */
    slot: string;
    icon: string;
    title: string;
    question: string;
};

/**
 * A card whose figures have not arrived yet.
 *
 * The header stays real — the icon, the title and the question are fixed
 * content and greying them out would tell the reader less than they already
 * know. Only the values are placeholders, and they sit where the values will
 * sit, so nothing reflows when the read lands.
 */
export const OverviewCardSkeleton: React.FC<OverviewCardSkeletonProps> = ({
    slot,
    icon,
    title,
    question,
}) => (
    <OverviewCard
        icon={icon}
        question={question}
        slot={`${slot}-skeleton`}
        title={title}
        tone={null}
    >
        <Skeleton className="h-4 w-full rounded" />
        <Skeleton className="h-4 w-2/3 rounded" />
        <Skeleton className="h-10 w-full rounded-xl" />
    </OverviewCard>
);
